import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getI18nFormattedMessage } from "../../../utils/intl";

export default (dict) => (label) => (
  <FormattedMessage id={label} defaultMessage={dict[label]} />
);

// Configuration Tab
export const KEY_NAME_LABEL = getI18nFormattedMessage('label.application.details.key.overview.column.keyname');
export const AUTHENTICATION_LABEL = getI18nFormattedMessage('label.application.details.key.overview.column.auth.provider');
export const STATUS_LABEL = getI18nFormattedMessage('label.application.details.key.overview.column.status');
export const DAYS_TO_KEY_EXPIRY_LABEL = getI18nFormattedMessage('label.application.details.key.overview.column.expirydays');

// APIs Tab
export const VERSION_TEXT = 'Version';
export const CHANGE_ACTION_TEXT = 'Change';
export const ADD_APIPLAN_ACTION_TEXT = 'Add API Plan';

// Deployments Tab
export const KEY_DEPLOYMENT_TYPE_LABEL = 'Key Deployment Type';
export const LAST_UPDATED_LABEL = 'Last Updated';

export const NO_RESULTS_TEXT = 'No results';
export const DEPLOYMENT_ACTION_TYPE_DEPLOY = 'DEPLOY';
export const DEPLOYMENT_ACTION_TYPE_REDEPLOY = 'REDEPLOY';
export const DEPLOYMENT_ACTION_TYPE_UNDEPLOY = 'UNDEPLOY';

export const DEPLOYMENT_ACTION_LABEL_DEPLOY = 'Deploy';
export const DEPLOYMENT_ACTION_LABEL_REDEPLOY = 'Redeploy';
export const DEPLOYMENT_ACTION_LABEL_UNDEPLOY = 'Undeploy';

export const MORE_INFO_TEXT = 'More Info';
export const CHECK_NOW_TEXT = 'Check now';
export const UPDATING_TEXT = 'Updating...';
export const VALIDATING_TEXT = 'Validating...';
export const UPDATING_STATUS_TEXT = 'Updating status: check in';
export const SECONDS_UNIT_TEXT = 's';

export const DEPLOYMENT_STATUS_ERROR = 'ERROR';
export const DEPLOYMENT_STATUS_LABEL_UNDEPLOYED = 'Not deployed';
export const DEPLOYMENT_STATUS_LABEL_VALIDATION_ERROR = 'Validation error';
export const DEPLOYMENT_STATUS_LABEL_DEPLOYMENT_ERROR = 'Deployment error';

export const APP_DEPLOYMENT_TYPE_AUTOMATIC = 'AUTOMATIC';
export const APP_DEPLOYMENT_TYPE_ON_DEMAND = 'ON_DEMAND';

export const APP_STATUS_ENABLED = 'ENABLED';
export const APP_STATUS_DISABLED = 'DISABLED';
export const KEY_STATUS_ENABLED = 'ENABLED';
export const KEY_STATUS_DISABLED = 'DISABLED';
export const KEY_STATUS_DELETE_FAILED = 'DELETE_FAILED';

export const INFORMATION_TEXT = 'Information';
export const WARNING_TEXT = 'Warning';
export const CONFIRM_ACTION_TEXT = 'Are you sure you want to perform this action?';
export const OK_TEXT = 'Ok';
export const CANCEL_TEXT = 'Cancel';
export const NOT_APPLICABLE_TEXT = 'n/a';

export const APPLICATION_REQUEST_FAILED_MORE_INFO = {
  details: {
    title: '',
    descriptions: '',
    subItems: [
      {
        id: 0,
        title: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.0.title"),
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.0.desc"),
      },
      {
        id: 0,
        title: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.delete.title"),
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.delete.desc"),
      },
      {
        id: 1,
        title: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.title" ),
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.desc"),
        list: {
          items : [
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.list.item.0"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.list.item.1"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.list.item.2"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.1.list.item.3"),
          ],
        },
      },
      {
        id: 2,
        title: '',
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.2.desc"),
      },
      {
        id: 3,
        title: '',
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.3.desc"),
      },
      {
        id: 4,
        title: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.title" ),
        descriptions: getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.desc"),
        list: {
          items : [
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.0"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.1"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.2"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.3"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.4"),
            getI18nFormattedMessage("label.application.details.section.failed.more.info.dialog.subitem.4.list.item.5"),
          ],
        },
      },
    ],
  },
};

